var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ordinance-unpublished"},[_c('div',{staticClass:"ordinance-unpublished__container"},[_c('h2',[_vm._v(_vm._s(_vm.ordinanceTitle))]),_c('RplCallToAction',{attrs:{"title":_vm.title,"summary":_vm.getSummary}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }